import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe';
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useParams } from "react-router-dom";
import axios from "axios";
import { config } from '../App';
import { Typography } from "@mui/material";

const VideoPlay = () => {
  const [data, setData] = useState({})
  const params = useParams()

  const [uV, setUV] = useState(0)
  const [dV, setDV] = useState(0)
  let patchURL = config.endpoint + `/v1/videos/${params.id}/votes`

  const upVote = (value) => {
    console.log('UpVote', value);
    axios.patch(patchURL, {vote: "upVote",change:"increase"}).then((res)=>{
      console.log(res, res.data);
    })
    setUV(uV+1)
  }

  const downVote = (value) => {
    console.log('DownVote', value);
    axios.patch(patchURL, {vote: "downVote",change:"decrease"}).then((res)=>{
      console.log(res, res.data);
    })
    setDV(dV+1)
  }

  let d1 = new Date()
  let d2 = new Date(data.releaseDate)
  let nDate = Math.abs(d1) - Math.abs(d2)
  // console.log(params.id);

  useEffect(() => {
    let getURL = config.endpoint + `/v1/videos/${params.id}`  
    axios.get(getURL).then((res)=> {
      console.log(res.data, res.data.votes, res.data.votes?.upVotes);
      setData(res.data)
      setUV(res.data.votes.upVotes)
      setDV(res.data.votes.downVotes)
    })
  }, [params.id])
  
  return (
      <>
        <Box borderRadius={2}>
          <Iframe
            url={`https://${data.videoLink}`}
            width="100%"
            height="400vh"
            display="initial"
            position="relative"
            allowFullScreen
            frameBorder="0"
            />
        </Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={3}
          >
          
          <Box mt={1} mb={1}>
            <Typography sx={{mt: 1, mb: 1}} variant={"title"} fontSize="16px" fontWeight="600">
              {data.title}
            </Typography>
            <Stack sx={{mt: 1, mb: 1}} direction="row" spacing={3}>
              <Typography variant={"body2"} fontSize="12px" fontWeight="300">
                {data.contentRating}
              </Typography>
              <FiberManualRecordIcon sx={{ fontSize: "10px", marginTop: "5px !important"}} color="close" />
              <Typography variant={"body2"} fontSize="12px" fontWeight="300">
                {Math.ceil(nDate/(1000*60*60*24*30))} months ago
              </Typography>
            </Stack>
          </Box>

          <Stack direction="row" spacing={1}>
            <Chip
              icon={<ThumbUpAltIcon />}
              label={uV}
              variant={"filled"}
              size="small"
              onClick={() => upVote(data.votes.upVotes)}
              />
            <Chip
              icon={<ThumbDownAltIcon />}
              label={dV}
              variant={"filled"}
              size="small"
              onClick={() => downVote(data.votes.downVotes)}
              />
          </Stack>
        </Stack>
        </>
  );
}

export default VideoPlay